export default "__VITE_ASSET__CkrB5ZQm__"